const Foldable = require("./foldable");
const Functor = require("./functor");
const Apply = require("./apply");
const Chain = require("./chain");
const Traversable = require("./traversable");
const Bifunctor = require("./bifunctor");
const Num = require("./num");
const Category = require("./category");

module.exports = {
  Foldable,
  Functor,
  Apply,
  Chain,
  Traversable,
  Bifunctor,
  Num,
  Category
};
